import request from "@/utils/request";

// 发送消息
export function send(data) {
  return request({
    url: "/ai/chat/message/send",
    method: "post",
    data,
  });
}
// 获取对话列表
export function list(data) {
  return request({
    url: "/ai/chat/conversation/my-list",
    method: "post",
    data,
  });
}
// 创建对话
export function create(data) {
  return request({
    url: "/ai/chat/conversation/create-my-export",
    method: "post",
    data,
  });
}
// 更新对话
export function update(data) {
  return request({
    url: "/ai/chat/conversation/update-my",
    method: "post",
    data,
  });
}
// 分页获取消息
export function page(data) {
  return request({
    url: "/ai/chat/message/page-v2",
    method: "post",
    data,
  });
}
// 文本嵌入
export function textEmbedding(data) {
  return request({
    url: "/ai/textEmbedding/textEmbedding",
    method: "post",
    data,
  });
}
// 发送流消息
export function sendStream(data) {
  return request({
    url: "/ai/chat/message/send-stream",
    method: "post",
    headers: {
      "Content-Type": "text/event-stream",
    },
    data,
  });
}
// 根据系统获取聊天消息
export function getChatMsgBySystem(data) {
  return request({
    url: "/ai/chat/conversation/addChatMsg",
    method: "post",
    data,
  });
}
// 获取AI命令中心
export function getAiCommandCenter(data) {
  return request({
    url: "/ai/chat/conversation/getAiCommandCenter",
    method: "post",
    data,
  });
}
// 获取分类
export function getAiCommandCenterGrouping(data) {
  return request({
    url: "/ai/chat/conversation/getAiCommandCenterGrouping",
    method: "post",
    data,
  });
}
export function delAiCommandCenter(data) {
  return request({
    url: "/ai/chat/conversation/delAiCommandCenter",
    method: "post",
    data,
  });
}
export function addAiCommandCenter(data) {
  return request({
    url: "/ai/chat/conversation/addAiCommandCenter",
    method: "post",
    data,
  });
}
export function deleteChat(data) {
  return request({
    url: "/ai/chat/conversation/delete-my",
    method: "post",
    data,
  });
}
export function saveAiChatShare(data) {
  return request({
    url: "/ai/chat/conversation/saveAiChatShare",
    method: "post",
    data,
  });
}
export function getAiChatShare(data) {
  return request({
    url: "/ai/chat/conversation/getAiChatShare",
    method: "post",
    data,
  });
}
export function createConversationByMessage(data) {
  return request({
    url: "/ai/chat/conversation/create-conversation-message",
    method: "post",
    data,
  });
}
export function getSuggestionQuestions(data) {
  return request({
    url: "/ai/chat/message/send-v2",
    method: "post",
    data,
  });
}
export function uploadFile(data) {
  return request({
    url: "/ai/chat/conversation/batchAddFile",
    method: "post",
    data,
    requestType: "blob",
  });
}
export function getAiToolRecommendations(data) {
  return request({
    url: "/ai/chat/conversation/getAiToolRecommendations",
    method: "post",
    data,
  });
}

export function anyApiPost(url, data) {
  return request({
    url,
    method: "post",
    data,
  });
}

export function getAiChatModel(data) {
  return request({
    url: "/ai/chat/conversation/getAiChatModel",
    method: "post",
    data,
  });
}
export function addAiChatModel(data) {
  return request({
    url: "/ai/chat/conversation/addAiChatModel",
    method: "post",
    data,
  });
}
export function getAiChatModelDetail(data) {
  return request({
    url: "/ai/chat/conversation/getAiChatModelDetail",
    method: "post",
    data,
  });
}
export function Exportanswer(data) {
  return request({
    url: "/ai/chat/conversation/export-answer",
    method: "post",
    data,
  });
}

export function feedback(data) {
  return request({
    url: "/ai/chat/conversation/feedback",
    method: "post",
    data,
  });
}

